/**
 * Search component.
 * @module components/theme/Search/Search
 */

import React, { Component } from 'react';
import Toolbar from '@plone/volto/components/manage/Toolbar/Toolbar';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import config from '@plone/volto/registry';
import { getSearchSettings } from 'govbr.frontend.policy/actions/search_settings/search_settings';
import { SearchResults } from 'govbr.frontend.policy/components';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { createPortal } from 'react-dom';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Container } from 'semantic-ui-react';

const messages = defineMessages({
  Search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
});

/**
 * Search class.
 * @class SearchComponent
 * @extends Component
 */
class Search extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  // Customizado: removidas propriedades da busca do Plone
  static propTypes = {
    searchableText: PropTypes.string,
    subject: PropTypes.string,
    pathname: PropTypes.string.isRequired,
    searchSettings: PropTypes.object,
  };

  /**
   * Default properties.
   * @property {Object} defaultProps Default properties.
   * @static
   */
  // Customizado: removidas propriedades da busca do Plone
  static defaultProps = {
    searchableText: null,
    subject: null,
    path: null,
  };

  constructor(props) {
    super(props);
    this.defaultPageSize = config.settings.defaultPageSize;
    this.state = { currentPage: 1, isClient: false, active: 'relevance' };
  }

  // Inicio da Customização
  fetchData = async () => {
    await this.props.getSearchSettings();
  };
  // Fim da Customização

  /**
   * Component did mount
   * @method componentDidMount
   * @returns {undefined}
   */
  componentDidMount() {
    // Inicio da Customização
    this.fetchData();
    // Fim da Customização
    this.setState({ isClient: true });
  }

  // Customização: remoção de código referente a busca do Plone e paginação
  // removidos os métodos UNSAFE_componentWillReceiveProps, doSearch,
  // handleQueryPaginationChange, onSortChange

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    // Inicio da Customização

    return (
      <>
        <Helmet title={this.props.intl.formatMessage(messages.Search)} />
        <Container id="page-search">
          <SearchResults
            searchableText={this.props.searchableText}
            tagBusca={this.props.subject}
            searchSettings={this.props.searchSettings}
          />
        </Container>
        {this.state.isClient &&
          createPortal(
            <Toolbar
              pathname={this.props.pathname}
              hideDefaultViewButtons
              inner={<span />}
            />,
            document.getElementById('toolbar'),
          )}
      </>
    );
  }
}

export default compose(
  injectIntl,
  connect(
    (state, props) => ({
      searchSettings: state.search_settings.data,
      pathname: props.history.location.pathname,
      searchableText: qs.parse(props.history.location.search).SearchableText,
      site_properties: state.site_properties.data,
    }),
    { getSearchSettings },
  ),
  // Fim da Customização
)(Search);
